module.exports = __webpack_public_path__ + "assets/paginator.768df7e3c1fefb24fa09bae9bedb7ac4.png";